module.exports = __webpack_public_path__ + "img/a790d5a.png";